import { useSearchParams } from "react-router-dom";
import { useAuthStore } from "@/store/auth";
import { PageHeader, Tabs } from "../components/ui";
import { DxfPresetsSection } from "./DxfPresetsPage";
import { MetadataPresetsSection } from "./MetadataPresetsPage";

type PresetsTab = "dxf" | "metadane";
const PRESETS_TABS: PresetsTab[] = ["dxf", "metadane"];

/* Presety modułu ZE w jednym miejscu: warstwy DXF (dla każdego) i metadane
   (szablony kolumn umowy — tylko dyrektorzy/CEO, jak RoleGuard starej trasy).
   Zakładka żyje w URL (?tab=metadane), żeby linki z zakładek projektu prowadziły
   prosto do właściwej sekcji; stare adresy /dxf-presets i /metadata-presets
   przekierowują tutaj. */
export function PresetsPage() {
  const user = useAuthStore((s) => s.user);
  const canSeeMetadata = !!user && (user.role === "director" || !!user.is_ceo);
  const [params, setParams] = useSearchParams();
  const raw = params.get("tab");
  let tab: PresetsTab = PRESETS_TABS.includes(raw as PresetsTab) ? (raw as PresetsTab) : "dxf";
  if (tab === "metadane" && !canSeeMetadata) tab = "dxf";
  const setTab = (k: PresetsTab) => setParams(k === "dxf" ? {} : { tab: k }, { replace: true });

  return (
    <div className="space-y-4">
      <PageHeader
        title="Presety"
        subtitle="Presety warstw DXF i szablony kolumn metadanych umowy · DLC_01"
      />

      <Tabs
        tabs={[
          { key: "dxf" as const, label: "Warstwy DXF" },
          ...(canSeeMetadata ? [{ key: "metadane" as const, label: "Metadane" }] : []),
        ]}
        active={tab}
        onChange={setTab}
      />

      {tab === "dxf" && <DxfPresetsSection />}
      {tab === "metadane" && canSeeMetadata && <MetadataPresetsSection />}
    </div>
  );
}
